import styled from "styled-components";

export const StyledAudioLevel = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
`;

export const StyledAudioLevelIcon = styled.div`
  min-width: 20px;
`;

export const StyledAudioLevelProgress = styled.div<{ $level: number }>`
  flex: 1 0 auto;
  height: 4px;
  background-color: var(--color-text-10);
  border-radius: var(--radius-md);
  overflow: hidden;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-color: var(--color-primary);
    width: ${({ $level }) => `${$level}%`};
  }
`;